import { render } from "./Boxes.vue?vue&type=template&id=5f6d4a7c"
import script from "./Boxes.vue?vue&type=script&lang=js"
export * from "./Boxes.vue?vue&type=script&lang=js"

import "./Boxes.vue?vue&type=style&index=0&id=5f6d4a7c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__